// 🔒
import { useState } from "react";
import { faqs } from "../data/faqs";

function FAQItem({ item, isOpen, onToggle }) {
  return (
    <article className={`faq-item ${isOpen ? "faq-item--open" : ""}`}>
      <button
        className="faq-item__button"
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-controls={`faq-answer-${item.id}`}
        id={`faq-question-${item.id}`}
        type="button"
      >
        <span className="faq-item__question">{item.question}</span>
        <span className="faq-item__icon" aria-hidden="true">
          {isOpen ? "−" : "+"}
        </span>
      </button>

      <div
        className="faq-item__content"
        id={`faq-answer-${item.id}`}
        role="region"
        aria-labelledby={`faq-question-${item.id}`}
      >
        <p>{item.answer}</p>
      </div>
    </article>
  );
}

export default function FAQPage() {
  const [openId, setOpenId] = useState(null);

  return (
    <section className="faq-list section" id="faq-list">
      <div className="container faq-list__container">
        <div className="faq-list__header">
          <p className="faq-list__label">Support</p>
          <h2>Answers to help you move faster</h2>
          <p className="faq-list__intro">
            Explore the most important answers about the app, coaching,
            payments, and how the platform works.
          </p>
        </div>

        <div className="faq-list__items">
          {faqs.map((item) => (
            <FAQItem
              key={item.id}
              item={item}
              isOpen={openId === item.id}
              onToggle={() =>
                setOpenId((prev) => (prev === item.id ? null : item.id))
              }
            />
          ))}
        </div>
      </div>
    </section>
  );
}
// 🔒